import { TApplicationState } from '../../types/redux';

export const getTimezone = (state: TApplicationState) => {
  return state.newbuilding.geo.timezone;
};
